import { apiFetch } from "../api.js";
import type {
  CreateInvitationInput,
  CreateInvitationOutput,
  InvitationPreview,
} from "./types.js";

export function createInvitation(
  input: CreateInvitationInput,
): Promise<CreateInvitationOutput> {
  return apiFetch<CreateInvitationOutput>("/v1/invitations", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function revokeInvitation(invitationId: string): Promise<void> {
  return apiFetch<void>(
    `/v1/invitations/${encodeURIComponent(invitationId)}/revoke`,
    { method: "POST" },
  );
}

/**
 * Public endpoint — used by the signup page to verify an invitation URL
 * before letting the user pick a password. Pass `auth: false` so the
 * client doesn't attach a stale JWT (the user isn't signed in yet).
 */
export function previewInvitation(
  invitationId: string,
  token: string,
): Promise<InvitationPreview> {
  return apiFetch<InvitationPreview>(
    `/v1/invitations/${encodeURIComponent(invitationId)}/preview?token=${encodeURIComponent(token)}`,
    { auth: false },
  );
}
